import VisualizarVendedorModal from './VisualizarVendedorModal';

export default VisualizarVendedorModal;
